// removed by extract-text-webpack-plugin
module.exports = {"header":"Header-style__header__c1d4dc75","title":"Header-style__title__c1d4dc75","close":"Header-style__close__c1d4dc75","closeButton":"Header-style__closeButton__c1d4dc75"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/views/modal/Header-style.scss
// module id = 463
// module chunks = 7 8 10 11 13 37